import React, { useCallback } from 'react'
import { FlexView } from '../../components/common'
import { useTranslation } from 'react-i18next'
import { MdCalendarToday } from 'react-icons/md'
import { PiStepsDuotone } from 'react-icons/pi'
import { CiLocationOn } from 'react-icons/ci'
import { GiOilRig } from 'react-icons/gi'
import styled from 'styled-components'
import moment from 'moment'

const CompareTable = styled.table`
  width: 100%;
  border-collapse: separate;
  border-spacing: 5px;
  
  th, td {
    border: 1px solid white;
    border-radius: 8px;
    text-align: center;
    padding: 8px;
    max-width: 50px;
  }

  td:first-child {
    text-align: left;
  }

  tr:nth-child(even) { background-color: #f2f2f2; }
`


const CompareTablePage = ({ compareItems, compareItemsDetails }) => {
    const { t } = useTranslation()

    const COMPARE_TABLE_ROWS = [
        { "pipesApplied": t("Pipes Applied") + " (joints)" },
        { "duration": t("Duration") + " (h)" },
        { "cumulativeLength": t("Cumulative Length") + " (m)" },
        { "avgSpeedJoints": t("Average Speed") + " (joint/h)" },
        { "avgSpeedMeters": t("Average Speed") + " (m/h)" },
        { "cruisingSpeedQuantity": "Cruising Speed (Max m in 1h)" },
        { "cruisingSpeedTime": "Cruising Speed (Max joints in 1h)" },
        { "rejectedQtd": t("Number of Rejects") + " (joints)" },
        { "plannedStoppagesQtd": t("Planned Stoppages") },
        { "unplannedStoppagesQtd": t("Unplanned Stoppages") },
    ]

    const getCompareItemValue = useCallback((jobId, compareTableRowIndex) => {
        const jobDetails = compareItemsDetails.find(item => item.jobId === jobId)

        if (!jobDetails) return "N/A"

        const itemFieldName = Object.keys(COMPARE_TABLE_ROWS[compareTableRowIndex])[0] || null

        if (!itemFieldName) return "N/A"

        return !isNaN(jobDetails[itemFieldName]?.value) ? Number(jobDetails[itemFieldName]?.value) : jobDetails[itemFieldName]?.value
    }, [COMPARE_TABLE_ROWS, compareItemsDetails])

    return (
        <FlexView width="100%" height="90%" style={{ overflowY: 'scroll' }}>
            <CompareTable>
                <thead>
                    <tr>
                        <th></th>
                        {
                            compareItems.map((item, index) => (<th key={index} style={{ alignItems: 'center', border: 'solid 1px #777777' }}>
                                {
                                    <FlexView flexDirection='column' alignItems='start'>
                                        <FlexView flexDirection='row' alignItems='center'>
                                            <GiOilRig size='25px' color='#59CBE4' style={{ marginRight: '2.5px' }} />
                                            <FlexView color='#777777' style={{ marginRight: '3px' }}>{t('Rig')}:</FlexView>
                                            {item.rig_name}
                                        </FlexView>
                                        <FlexView flexDirection='row' alignItems='center'>
                                            <MdCalendarToday size='18px' color='#59CBE4' style={{ marginRight: '5px', marginLeft: '3.8px' }} />
                                            <FlexView color='#777777' style={{ marginRight: '3px' }}>{t('Date')}:</FlexView>
                                            {moment(item.job_date).format('DD/MM/YYYY')}
                                        </FlexView>
                                        <FlexView flexDirection='row' alignItems='center'>
                                            <CiLocationOn size='22.5px' color='#59CBE4' style={{ marginRight: '4px' }} />
                                            <FlexView color='#777777' style={{ marginRight: '3px' }}>{t('Well')}:</FlexView>
                                            {item.well}
                                        </FlexView>
                                        <FlexView flexDirection='row' alignItems='center'>
                                            <PiStepsDuotone size='22.5px' color='#59CBE4' style={{ marginRight: '4px' }} />
                                            <FlexView color='#777777' style={{ marginRight: '3px' }}>{t('WellSection')}:</FlexView>
                                            {item.well_section}
                                        </FlexView>
                                    </FlexView>
                                }
                            </th>))
                        }
                    </tr>
                </thead>
                <tbody>
                    {
                        COMPARE_TABLE_ROWS.map((row, compareTableRowIndex) => (
                            <tr key={compareTableRowIndex}>
                                <td style={{ border: 'solid 1px #777777' }}>{Object.values(row)[0]}</td>
                                {
                                    compareItems.map((item, index) => (<td style={{ border: 'solid 1px #777777' }} key={index}>{getCompareItemValue(item.job_id, compareTableRowIndex)}</td>))
                                }
                            </tr>
                        ))
                    }
                </tbody>
            </CompareTable>
        </FlexView>
    )
}

export default CompareTablePage